module.exports = __webpack_public_path__ + "img/coupon2022f1-sp.215dc53c.jpg";